import { QuestionMarkCircleIcon } from '@heroicons/react/24/outline';
import * as React from 'react';
import * as LabelPrimitive from '@radix-ui/react-label';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from 'shared/src/utils';
import { ScreenReaderHidden } from '../../Accessibility';
import { TooltipProvider, Tooltip, TooltipContent, TooltipTrigger } from './Tooltip';

export const labelVariants = cva('', {
  variants: {
    variant: {
      default: 'block text-sm font-medium leading-6 text-gray-900',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

const Label = React.forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root> & VariantProps<typeof labelVariants> & { required?: boolean; tooltip?: string; tooltipClassName?: string }
>(({ className, variant, tooltip, tooltipClassName = 'size-4', required, children, ...props }, ref) => (
  <LabelPrimitive.Root ref={ref} className={cn(labelVariants({ variant, className }), 'flex items-center space-x-1', className)} {...props}>
    {children}
    {required ? <ScreenReaderHidden className="text-error">*</ScreenReaderHidden> : null}
    {tooltip ? (
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger>
            <QuestionMarkCircleIcon className={tooltipClassName} />
          </TooltipTrigger>
          <TooltipContent className="max-w-sm">{tooltip}</TooltipContent>
        </Tooltip>
      </TooltipProvider>
    ) : null}
  </LabelPrimitive.Root>
));

Label.displayName = LabelPrimitive.Root.displayName;

export { Label };
